import {
  Announcement01, Building07, CalendarDate, LayoutGrid01, MarkerPin02, User01, Users01, copyText
} from "@opendate-app/setlist";
import buildHoldDatesText from "../../OfferEditUI/utils/buildHoldDatesText";
import { toastError, toastSuccess } from "../../../shared/toastHelper";
import { showDateLabel, showTimeLabel } from "../../../shared/showTimeLabel";

const GUARDIAN_RESTRICTION = "Under 18 must be accompanied by parent or guardian";

const holdItem = (confirm, team, timeZone) => {
  const positions = [...(confirm.hold_positions || [])]
    .sort((a, b) => new Date(a.start_time) - new Date(b.start_time));
  if (positions.length === 0) return null;

  const first = showDateLabel(positions[0].start_time, timeZone);
  const last = showDateLabel(positions[positions.length - 1].start_time, timeZone);
  const label = positions.length === 1 ? `1 Hold · ${first}` : `${positions.length} Holds · ${first} – ${last}`;

  const copyHoldDates = () => {
    const text = buildHoldDatesText(positions, confirm.venue?.name, timeZone, team?.append_availability_disclaimer_to_hold_dates);
    copyText(text).then((ok) => (
      ok ? toastSuccess("Copied hold dates to clipboard") : toastError("Couldn't copy hold dates to clipboard")
    ));
  };

  return { icon: CalendarDate, label, onClick: copyHoldDates };
};

const roomLabel = (venueName, room) => (room && room.name !== venueName ? `${venueName} - ${room.name}` : venueName);

const venueItems = (confirm) => {
  if (!confirm.venue) return [];
  if (confirm.venue_ownership_rooms_count === 1) {
    return [{ icon: Building07, label: roomLabel(confirm.venue.name, confirm.rooms?.[0]) }];
  }
  return [...(confirm.rooms || [])]
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((room) => ({ icon: Building07, label: roomLabel(confirm.venue.name, room) }));
};

const classicHeaderMeta = (confirm, team) => {
  const timeZone = confirm.venue_ownership?.tzinfo_identifier || confirm.venue?.time_zone || "America/New_York";
  const dateItem = confirm.type === "Confirm" && confirm.start_time
    ? {
      icon: CalendarDate,
      label: confirm.multi_day && confirm.human_date_and_time_with_day_of_week
        ? confirm.human_date_and_time_with_day_of_week
        : showTimeLabel(confirm.start_time, confirm.door_time, timeZone),
    }
    : confirm.type === "Hold" && holdItem(confirm, team, timeZone);

  return [
    dateItem,
    ...venueItems(confirm),
    confirm.venue?.city_and_state && { icon: MarkerPin02, label: confirm.venue.city_and_state },
    confirm.age_restriction && {
      icon: Users01,
      label: confirm.age_restriction === GUARDIAN_RESTRICTION ? "Under 18 w/ Guardian" : confirm.age_restriction,
    },
    confirm.buyer?.name && { icon: User01, label: `Buyer · ${confirm.buyer.name}` },
    confirm.promoter?.name && { icon: Announcement01, label: `Promoter · ${confirm.promoter.name}` },
    confirm.event_template?.name && { icon: LayoutGrid01, label: `Template · ${confirm.event_template.name}` },
  ].filter(Boolean);
};

export default classicHeaderMeta;
